// Staff-only route: /preview-keepsake/{orderId}
// Renders the full customer keepsake experience for any order by ID —
// bypasses the customer-facing tokenId validation so Dan can inspect the
// layout for historical uploads, completed orders, etc. without having a
// live ticket.
//
// Auth-gated at the App.js route level. This component just fetches the
// order doc and mounts PancakeKeepsake in its normal (non-preview) mode so
// all commerce/email zones + modals render as the customer would see them.

import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import PancakeKeepsake from "../components/PancakeKeepsake";

export default function KeepsakePreview({ orderId, navigate }) {
  const [order, setOrder] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!orderId) { setLoaded(true); return; }
    const unsub = onSnapshot(doc(db, "orders", orderId), (snap) => {
      setOrder(snap.exists() ? { id: snap.id, ...snap.data() } : null);
      setLoaded(true);
    }, () => setLoaded(true));
    return unsub;
  }, [orderId]);

  if (!loaded) {
    return (
      <div style={pageStyle}>
        <p style={{ color: "#ffdaad" }}>Loading…</p>
      </div>
    );
  }
  if (!order) {
    return (
      <div style={pageStyle}>
        <p style={{ color: "#ff8a8a", marginBottom: "1rem" }}>Order not found.</p>
        <button onClick={() => navigate("/library?tab=pancakes")} style={backBtn}>← Library</button>
      </div>
    );
  }

  return (
    <>
      {/* Floating staff badge — reminds Dan this is a preview, not a real
          customer session. Absolutely positioned over the top-right so it
          doesn't interfere with keepsake layout. */}
      <div style={{
        position: "fixed",
        top: "0.75rem",
        right: "0.75rem",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
        background: "rgba(26,10,18,0.9)",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
        border: "1px solid rgba(252,179,31,0.45)",
        borderRadius: "999px",
        padding: "0.35rem 0.85rem",
        color: "#fcb31f",
        fontSize: "0.78rem",
        fontWeight: 700,
        fontFamily: "var(--jop-display)",
        letterSpacing: "0.06em",
      }}>
        🔍 STAFF PREVIEW
        <button
          onClick={() => navigate("/library?tab=pancakes")}
          style={{
            background: "transparent",
            border: "1px solid rgba(252,179,31,0.4)",
            color: "#fcb31f",
            borderRadius: "999px",
            padding: "0.2rem 0.6rem",
            fontSize: "0.72rem",
            fontWeight: 700,
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          ← Back
        </button>
      </div>

      <PancakeKeepsake order={order} db={db} />
    </>
  );
}

const pageStyle = {
  background: "#0d1833",
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "2rem",
  fontFamily: "var(--jop-display)",
};

const backBtn = {
  background: "transparent",
  color: "rgba(255,218,173,0.75)",
  border: "1px solid rgba(255,218,173,0.3)",
  borderRadius: "8px",
  padding: "0.5rem 1rem",
  fontSize: "0.9rem",
  fontWeight: 600,
  cursor: "pointer",
  fontFamily: "inherit",
};
